import { motion } from 'framer-motion';

export default function Services() {
  const services = [
    {
      title: 'Deep Clean Service',
      description: 'We scrub, sanitize, and deodorize your trash cans inside and out. Using eco-friendly products, we remove dirt, grime, and bad smells to make your bins look and smell brand new!',
      icon: 'ri-delete-bin-fill',
      color: 'bg-red-500',
      rotation: '-rotate-2'
    },
    {
      title: 'Subscription Plans',
      description: 'Save money with our monthly or quarterly cleaning plans! Never worry about scheduling again - we come to you automatically and keep your cans fresh all year long.',
      icon: 'ri-calendar-check-fill',
      color: 'bg-yellow-400',
      rotation: 'rotate-1'
    },
    {
      title: 'Kid-Friendly Service',
      description: 'Our team of young entrepreneurs learns responsibility while providing excellent service! We are polite, hardworking, and committed to making your neighborhood cleaner.',
      icon: 'ri-team-fill',
      color: 'bg-blue-600',
      rotation: '-rotate-1'
    }
  ];

  return (
    <section id="services" className="py-16 sm:py-24 bg-gradient-to-br from-yellow-100 via-red-100 to-blue-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 sm:mb-16"
        >
          <h2 className="text-5xl sm:text-6xl md:text-7xl font-black text-red-500 mb-4 sm:mb-6" style={{ fontFamily: 'Fredoka, system-ui, sans-serif' }}>
            What We Do
          </h2>
          <p className="text-lg sm:text-xl md:text-2xl text-gray-700 max-w-3xl mx-auto px-4">
            We make your trash cans sparkle! Here's what makes us special:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2, duration: 0.6 }}
              whileHover={{ scale: 1.05, rotate: 0 }}
              className={`${service.color} ${service.rotation} rounded-[32px] p-12 shadow-xl cursor-pointer transition-all`}
            >
              <div className="text-white">
                <div className="w-24 h-24 flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-7xl drop-shadow-lg`}></i>
                </div>
                <h3 className="text-3xl font-bold mb-4 drop-shadow-md" style={{ fontFamily: 'Fredoka, system-ui, sans-serif' }}>
                  {service.title}
                </h3>
                <p className="text-lg leading-relaxed font-medium drop-shadow-sm">
                  {service.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
